module.exports = __webpack_public_path__ + "static/media/DashMenu.f2cec381.svg";